module.exports = __webpack_public_path__ + "static/img/18.a4980606.jpg";